module.exports = __webpack_public_path__ + "img/1F1E9-1F1FF.8f9e59f8.svg";